import type { Release } from '../releases.ts';

export default {
  version: '0.20.1',
  date: '2026-10-03',
  title: 'Easier agent installation',
  summary: [
    'Agent installation is three numbered steps, each with a copy button',
    'Install or update on an agent’s page shows the update command',
    'Fixed: the Site field in Add a storage agent can be typed in',
    'Fixed: pasting the whole install block no longer answers the setup questions',
  ],
  features: [
    'The single-file install in Add agent is now three numbered steps, each with its own copy button, with Storage folder and Watch folder fields (suggested per computer type) that go straight into the `configure` command, so nothing has to be answered in the terminal',
    'On a storage agent’s page, “Install or update…” opens the same window: the `prism-agent update` command, and the install steps for another computer or a reinstall, with a button that creates a fresh enrolment token',
  ],
  fixes: [
    'In “Add a storage agent” the Site field could not be typed in because focus jumped back to Name after every letter; every dialog is fixed',
    'Pasting the whole install block into a terminal no longer feeds the later commands to the questions `configure` asks',
  ],
} satisfies Release;
